import React from 'react';
import classNames from 'classnames';
import { getPrefixCls } from '../configure';
const Meta = (props) => {
    const { prefixCls: customizePrefixCls, className, avatar, title, description, ...others } = props;
    const prefixCls = getPrefixCls('card', customizePrefixCls);
    const classString = classNames(`${prefixCls}-meta`, className);
    const avatarDom = avatar ? React.createElement("div", { className: `${prefixCls}-meta-avatar` }, avatar) : null;
    const titleDom = title ? React.createElement("div", { className: `${prefixCls}-meta-title` }, title) : null;
    const descriptionDom = description ?
        React.createElement("div", { className: `${prefixCls}-meta-description` }, description) : null;
    const MetaDetail = titleDom || descriptionDom ?
        React.createElement("div", { className: `${prefixCls}-meta-detail` },
            titleDom,
            descriptionDom) : null;
    return (React.createElement("div", Object.assign({}, others, { className: classString }),
        avatarDom,
        MetaDetail));
};
Meta.displayName = 'CardMeta';
export default Meta;
